import {
  AmountType,
  AutoTradingType,
  BaseBotData,
  BasicBotData,
  BotData,
  BotType,
  DisplayResultMessage,
  MainCoinAmountData,
  MainCoinsAvailableAmountsData,
} from "@shared/types";
import { ReactNode } from "react";
import { PercentageBaseType } from "@shared/features/bots/BotForm/common/types";

export enum MyBotsSort {
  NAME = "Bot Name",
  TOTAL_PROFIT = "Closed Trades Profit",
  CLOSED_TRADES = "Number of Closed Trades",
  OPEN_TRADES = "Number of Open Trades",
  REALIZED_PNL = "Realized PnL",
  TAKE_PROFITS_FILLED = "Take-profits Filled",
  LAST_ENTRY = "Last Entry Filled",
  NEXT_TAKE_PROFIT = "Take-Profit Distance",
  NEXT_ENTRY_OR_STOP = "Next Entry/Stop Distance",
  SYMBOL = "Symbol",
  CREATED = "Created Date",
  AMOUNT = "Amount",
  LAST_TRADE_OPENED = "Last Trade Opened",
}

export enum BotsTab {
  MY_BOTS = "my-bots",
  PUBLIC_BOTS = "public-bots",
}

export enum MobileBotsTab {
  MY_BOTS = "myBots",
  BACKTESTING = "backtesting",
  PUBLIC = "public",
}

export interface AmountData {
  mainCoin: number;
  BTCAmount: number;
  USDAmount: number;
}

export interface BotAmountData extends MainCoinsAvailableAmountsData {
  convertMainCoinAmountToAmountType: (
    amount: number,
    applyPrecision?: boolean,
    amountType?: AmountType
  ) => number | undefined;
  mainCoinAmount: number;
  showAmountWarning?: boolean;
  availableAmount: AmountData;
  getSelectedAmount?: (
    amountData?: MainCoinAmountData,
    amountType?: AmountType,
    amountValue?: number
  ) => number;
  initialized: boolean;
  amountType?: AmountType;
  amountValue?: number;
  amountPercentageBaseType?: PercentageBaseType;
  amountCustomBaseValue?: number;
}

export enum PublicBotSummaryTabs {
  SUMMARY = "Summary",
  STATISTICS = "Statistics",
}

export enum BulkUpdateBotStep {
  CLOSE_TRADES = 1,
  CONFIRM_INACTIVE_ACCOUNT = 2,
  CONFIRM = 3,
}

export interface UseSharedBulkUpdateBotsModalProps {
  open?: boolean;
  botsIDs?: number[];
  closeModal: () => void;
  isDeactivate?: boolean;
  onFinish?: () => void;
  displayResultMessage: DisplayResultMessage;
  botType: BotType;
  botIDToBotData: Record<number, BotData | BasicBotData>;
}

export type BulkUpdateBotsModalProps = Omit<
  UseSharedBulkUpdateBotsModalProps,
  "displayResultMessage"
>;

export interface BulkDeleteBotsModalProps {
  isOpen?: boolean;
  closeModal: () => void;
  onOk?: () => void;
  content?: ReactNode;
  isLoading?: boolean;
}

export interface ConfirmAutoTradingActiveModalProps {
  isOpen: boolean;
  onCancel: () => void;
  isBulk?: boolean;
  onOk?: () => void;
  autoTradingType: AutoTradingType;
  isLoading?: boolean;
}

export interface BotConfigurationModalProps {
  bot?: BaseBotData;
  closeModal: () => void;
  open?: boolean;
  isFetching?: boolean;
  isBulkEdit?: boolean;
  showAmount?: boolean;
  title?: string;
  isChannelConfiguration?: boolean;
}

export enum BotExtraDetailsTabs {
  GENERAL = "general",
  TIMELINE = "active-trade",
}

export enum SignalsBotSummaryTab {
  MOST_TRADED_PAIR = "Most Traded Pairs",
  BACKTESTING_HISTORY = "Backtesting History",
}

export type SubGroupSignalFrequencyResponse = {
  last_signal_open_time: number;
  signals_frequency: number;
};
